export default __webpack_public_path__ + "static/media/be-icon-new.fab6b8d9.svg";